import { useParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { UserRole } from "@/generated/types";
import { useProjectContext } from "./contexts/ProjectContext";
import ProjectShell from "./components/ProjectShell";
import InfoTab from "./components/InfoTab";

function ProjectInfoContent({ projectId }: { projectId: string }) {
  const { project, refetch } = useProjectContext();
  const { currentUser } = useAuth();
  const canManageMembers = !!(
    (currentUser?.role === UserRole.Admin || currentUser?.role === UserRole.Collaborator) &&
    project.members?.some((m) => m.id === currentUser.id)
  );

  return (
    <InfoTab
      project={project}
      projectId={projectId}
      canManageMembers={canManageMembers}
      onMemberRemoved={refetch}
      onInvitationCancelled={refetch}
    />
  );
}

export default function ProjectDetail() {
  const { id } = useParams<{ id: string }>();

  return (
    <ProjectShell projectId={id!} activeTab="info">
      <ProjectInfoContent projectId={id!} />
    </ProjectShell>
  );
}
